// Abstraction cartographique (Master Prompt §2.13) — fournisseur actuel : OpenStreetMap / Nominatim.
// Toute la logique carte/navigation est centralisée ici : un changement de fournisseur
// ne touchera que ce module, pas l'Agenda.

export const hasGeo = (geo) =>
  !!(geo && typeof geo.lat === "number" && typeof geo.lon === "number");

// Mini-carte embarquée (iframe OSM avec marqueur) centrée sur le lieu.
export function osmEmbedUrl(lat, lon) {
  const dLat = 0.004;
  const dLon = 0.008;
  const bbox = [lon - dLon, lat - dLat, lon + dLon, lat + dLat].map((v) => v.toFixed(6)).join("%2C");
  return `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat.toFixed(6)}%2C${lon.toFixed(6)}`;
}

// Liens universels : ouvrent l'app native si elle est installée, sinon la version web (dégradation propre).
export function googleNavUrl(geo) {
  return `https://www.google.com/maps/dir/?api=1&destination=${geo.lat},${geo.lon}`;
}

export function wazeNavUrl(geo) {
  return `https://waze.com/ul?ll=${geo.lat},${geo.lon}&navigate=yes`;
}

export function appleNavUrl(geo) {
  const label = encodeURIComponent(geo.name || geo.address || "Destination");
  return `https://maps.apple.com/?daddr=${geo.lat},${geo.lon}&q=${label}`;
}

// Fallback Web : destination visible sur une carte même sans application de navigation.
export function osmWebUrl(geo) {
  return `https://www.openstreetmap.org/?mlat=${geo.lat}&mlon=${geo.lon}#map=17/${geo.lat}/${geo.lon}`;
}

// Ouvre une destination : sur mobile dans la page courante (l'OS intercepte le lien universel
// et propose/ouvre l'app), sur desktop dans un nouvel onglet.
export function openUrl(url) {
  const ua = navigator.userAgent || "";
  if (/android|iphone|ipad|ipod/i.test(ua)) {
    window.location.href = url;
  } else {
    window.open(url, "_blank", "noopener");
  }
}
